'use client';

const HOW_TRADE_IN_EVENTS_WORK = [
  {
    title: 'Bring your gear',
    description:
      'We accept all sports and outdoor gear in good working condition that was purchased in the last 5 years. Be sure to check our trade-in guidelines for more info. ',
    icon: (
      <svg
        width="105"
        height="95"
        viewBox="0 0 105 95"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_155_2947)">
          <path
            d="M103.38 38.53H1V23.56C24.83 23.55 52.19 1 52.19 1C52.19 1 82.12 23.55 103.38 23.55V38.52V38.53Z"
            fill="#E1FFF1"
          />
          <path
            d="M103.38 38.53H1V23.56C24.83 23.55 52.19 1 52.19 1C52.19 1 82.12 23.55 103.38 23.55V38.52V38.53Z"
            stroke="#002817"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 38.5298V93.0498"
            stroke="#002817"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.38 38.5298V93.0498"
            stroke="#002817"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.88 61.52C81.88 61.52 20.49 61.52 22.5 61.52C24.51 61.52 24.5 81.55 24.5 81.55H79.88C79.88 81.55 79.88 61.52 81.88 61.52Z"
            fill="#E1FFF1"
          />
          <path
            d="M82 62.0089C82 62.0089 26.4776 61.9889 23 62.0089C24.9872 65.4821 24.9872 82 24.9872 82H80.0128C80.0128 82 80.0128 64.9831 82 62.0089Z"
            stroke="#02C874"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="25"
            y1="82"
            x2="25"
            y2="93"
            stroke="#02C874"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="80"
            y1="82"
            x2="80"
            y2="93"
            stroke="#02C874"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_155_2947">
            <rect width="104.38" height="94.05" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: 'Get a quote',
    description:
      'Pricing is based on SidelineSwap market data so you always get the best price for your gear. We’ll complete your quote while you shop or play.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="95"
        fill="none"
      >
        <path
          fill="#fff"
          stroke="#231F20"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m68.721 93.002-8.467-5.022-8.466 5.022-8.467-5.022-8.455 5.022L26.4 87.98l-8.467 5.022-8.466-5.022L1 93.002v-92h67.721v92Z"
        />
        <path
          fill="#E1FFF1"
          stroke="#02C874"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M25.947 39.002c8.332 0 15.087-6.716 15.087-15C41.034 15.716 34.28 9 25.947 9s-15.086 6.717-15.086 15.001c0 8.285 6.754 15.001 15.086 15.001Z"
        />
        <path
          fill="#E1FFF1"
          d="M29.09 16.035h-4.41c-2.218 0-4.012 1.784-4.012 3.989 0 2.204 1.794 3.988 4.012 3.988h2.537c2.217 0 4.012 1.785 4.012 3.99 0 2.204-1.795 3.988-4.012 3.988h-5.658"
        />
        <path
          stroke="#02C874"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M29.09 16.035h-4.41c-2.218 0-4.012 1.784-4.012 3.989 0 2.204 1.794 3.988 4.012 3.988h2.537c2.217 0 4.012 1.785 4.012 3.99 0 2.204-1.795 3.988-4.012 3.988h-5.658m4.388-18.284v20.296"
        />
        <path
          stroke="#02C874"
          strokeWidth="2"
          d="M12.861 49.002h44m-44 10.001h44m-44 10.001h44m-44 10h30"
        />
      </svg>
    ),
  },
  {
    title: 'Get paid',
    description:
      'Payments are issued instantly for your trade-in value. Check event details for which payment options will be offered.',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="89"
        fill="none"
      >
        <path
          fill="#E1FFF1"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M35.366 40.659c11.014 0 19.944-8.878 19.944-19.83C55.31 9.878 46.38 1 35.366 1 24.35 1 15.42 9.878 15.42 20.83c0 10.95 8.93 19.829 19.945 19.829Z"
        />
        <path
          fill="#E1FFF1"
          d="M39.52 10.299h-5.83c-2.932 0-5.304 2.358-5.304 5.273 0 2.914 2.372 5.272 5.304 5.272h3.354c2.931 0 5.303 2.359 5.303 5.273 0 2.915-2.372 5.273-5.303 5.273h-7.48"
        />
        <path
          stroke="#02C874"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M39.52 10.299h-5.83c-2.932 0-5.304 2.358-5.304 5.273 0 2.914 2.372 5.272 5.304 5.272h3.354c2.931 0 5.303 2.359 5.303 5.273 0 2.915-2.372 5.273-5.303 5.273h-7.48m5.802-24.17v26.829"
        />
        <path
          fill="#fff"
          d="m47.31 67.807-13.944.916c-1.889.13-3.898-1.193-4.457-2.938v-.044c-.574-1.745.438-3.549 2.266-4.029l17.026-4.436c1.526-.393 3.882-.117 5.257.64L70 66.919v17.179H41.04c-1.586 0-4.033-.51-5.469-1.135L3.258 68.853C.715 67.736.995 65.997 1.022 64.739c.04-1.84 2.01-2.75 3.731-2.473l23.794 3.738"
        />
        <path
          stroke="#002817"
          strokeLinecap="round"
          strokeMiterlimit="35"
          strokeWidth="2"
          d="m47.31 67.807-13.944.916c-1.889.13-3.898-1.193-4.457-2.938v-.044c-.574-1.745.438-3.549 2.266-4.029l17.026-4.436c1.526-.393 3.882-.117 5.257.64L70 66.919v17.179H41.04c-1.586 0-4.033-.51-5.469-1.135L3.258 68.853C.715 67.736.995 65.997 1.022 64.739c.04-1.84 2.01-2.75 3.731-2.473l23.794 3.738"
        />
        <path
          fill="#E1FFF1"
          stroke="#002817"
          strokeMiterlimit="35"
          strokeWidth="2"
          d="M70 62.098v25h9v-25h-9Z"
        />
      </svg>
    ),
  },
];

export function HowTradeInEventsWork() {
  return (
    <div className="grid gap-8 md:grid-cols-3">
      {HOW_TRADE_IN_EVENTS_WORK.map(group => (
        <div
          key={group.title}
          className="bg-white px-4 py-3 shadow-lg md:px-8 md:py-6"
        >
          <div className="flex w-full items-center justify-between md:flex-col-reverse md:items-start">
            <h4 className="my-4 text-xl font-semibold">{group.title}</h4>
            <div className="md:mb-6">{group.icon}</div>
          </div>

          <p className="prose mt-4">{group.description}</p>
        </div>
      ))}
    </div>
  );
}
